enum CommodityType {
  Electricity = 1,
  Gas = 2,
}

export default CommodityType;
